/**
 * apiServerStore.ts
 * ------------------
 * This module holds the currently selected API server URL at the module level.
 * 
 * It provides simple getter/setter functions that allow components and utility
 * functions (like `genericRequest`) to share the same selected API server value
 * without needing React Context or prop drilling.
 * 
 * Usage:
 *   import { setSelectedServer, getSelectedServer } from "./apiServerStore";
 * 
 *   // In your selector component:
 *   setSelectedServer("https://myapi.example.com");
 * 
 *   // In your API utility:
 *   const baseUrl = getSelectedServer();
 *   await genericRequest({ url: `${baseUrl}/api/resource`, method: "GET" });
 */


const STORAGE_KEY = "selectedApiServer";
const DEFAULT_SERVER = "https://api.starsubtera.tech";

let selectedServer = localStorage.getItem(STORAGE_KEY) ?? DEFAULT_SERVER;

export const setSelectedServer = (v: string): void => {
  console.log("Setting selected API server to:", v);
  selectedServer = v;
  localStorage.setItem(STORAGE_KEY, v);
};

export const getSelectedServer = (): string => selectedServer;
